module.exports = __webpack_public_path__ + "h5/img/summer-data-banner.592e0ac4.png";